import { Outlet, useNavigate, useLocation, Navigate } from "react-router-dom";
import { Home, CalendarDays, LineChart, BookOpen, User } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { key: "home", label: "Home", icon: Home, path: "/home" },
  { key: "journey", label: "30 Days", icon: CalendarDays, path: "/journey" },
  { key: "track", label: "Track", icon: LineChart, path: "/track" },
  { key: "toolkit", label: "Toolkit", icon: BookOpen, path: "/toolkit" },
  { key: "profile", label: "Profile", icon: User, path: "/profile" },
];

export default function AppLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  // gating: customers must have active access (trial or subscription) + completed onboarding
  if (user && user.role !== "admin") {
    if (!user.access_active) return <Navigate to="/checkout" replace />;
    if (!user.onboarding_complete) return <Navigate to="/onboarding" replace />;
  }

  return (
    <div className="bg-app min-h-screen">
      <div className="app-frame pb-24">
        <Outlet />
      </div>

      <nav
        className="fixed bottom-0 left-0 right-0 z-50 backdrop-blur-xl border-t border-subtle"
        style={{ backgroundColor: "rgba(250,248,245,0.92)" }}
        data-testid="bottom-nav"
      >
        <div className="max-w-[480px] mx-auto flex justify-around items-center h-16 px-2">
          {NAV.map((item) => {
            const active = location.pathname === item.path;
            const Icon = item.icon;
            return (
              <button
                key={item.key}
                data-testid={`nav-${item.key}`}
                onClick={() => navigate(item.path)}
                className="flex flex-col items-center justify-center gap-1 flex-1 h-full transition-colors"
              >
                <Icon
                  size={22}
                  strokeWidth={active ? 2.4 : 1.8}
                  className={active ? "text-brand" : "text-ink-muted"}
                />
                <span
                  className={`text-[10px] font-semibold tracking-wide ${
                    active ? "text-brand" : "text-ink-muted"
                  }`}
                >
                  {item.label}
                </span>
              </button>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
